export function twentyFourHourForecastOptions (railwayData) {
  const colors = ['#87C1FD', '#EF9B9D', '#FFC171']
  const options = {
    title: {
      text: '24小时天气预报',
      textStyle: {
        fontSize: 16,
        color: '#333'
      },
      top: '5px'
    },
    color: colors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      formatter: function (params) {
        let relVal = params[0].name
        const unitArray = { 温度: '℃', 风速: 'm/s', 雨量: 'mm' }
        console.log(params[0].name)
        for (let i = 0, l = params.length; i < l; i++) {
          relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value + ' ' + unitArray[params[i].seriesName]
        }
        return relVal
      }
    },
    grid: {
      top: '25%',
      right: '20%',
      bottom: '10%'
    },
    legend: {
      data: ['温度', '风速', '雨量'],
      top: '5px',
      right: '0'
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      data: railwayData.xText
    }],
    yAxis: [{
      type: 'value',
      name: '(℃)',
      axisLine: {
        show: true
      },
      axisLabel: {
        formatter: '{value}'
      },
      splitLine: {
        show: false
      }
    }, {
      type: 'value',
      name: '(m/s)',
      position: 'right',
      axisLine: {
        show: true
      },
      axisLabel: {
        formatter: '{value}'
      },
      splitLine: {
        show: false
      }
    }, {
      type: 'value',
      name: '(mm)',
      position: 'right',
      offset: 50,
      axisLine: {
        show: true
      },
      axisLabel: {
        formatter: '{value}'
      },
      splitLine: {
        show: false
      }
    }],
    series: [{
      name: '温度',
      type: 'line',
      data: railwayData.tempGroup
    }, {
      name: '风速',
      type: 'line',
      yAxisIndex: 1,
      data: railwayData.windGroup
    }, {
      name: '雨量',
      type: 'bar',
      yAxisIndex: 2,
      data: railwayData.rainGroup
    }
    ]
  }
  return options
}
/**
 * 优化坐标轴美观效果
 * @param {Array} data
 * @param {Number} splitNumber 分割成几段
 * @param {Number} min  最小值限制（例如风速最小值为0）
 * @param {Number} max  最大值限制（例如相对湿度最大值为100）
 */
function getMinMax (data, splitNumber, min, max) {
  if (data && data.length > 0) {
    let minValue = data[0]
    let maxValue = data[0]
    data.forEach(element => {
      if (element < minValue) {
        minValue = element
      }
      if (element > maxValue) {
        maxValue = element
      }
    })
    minValue *= 10
    maxValue *= 10
    maxValue -= (maxValue - minValue) % splitNumber
    const sn = (maxValue - minValue) / splitNumber
    minValue = (minValue - sn * 2) / 10
    maxValue = (maxValue + sn * 2) / 10
    if (min && min > minValue && max && max < maxValue) {
      minValue = min
      maxValue = max
    } else {
      if (min && min > minValue) {
        minValue = min
        maxValue += sn - (maxValue - minValue) % splitNumber
      }
      if (max && max < maxValue) {
        maxValue = max
        minValue -= sn - (maxValue - minValue) % splitNumber
      }
    }
    return [minValue, maxValue]
  }
}
